import { render, staticRenderFns } from "./AssignedJobFamilyTag.vue?vue&type=template&id=38f0dc2a&scoped=true"
import script from "./AssignedJobFamilyTag.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignedJobFamilyTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AssignedJobFamilyTag.vue?vue&type=style&index=0&id=38f0dc2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f0dc2a",
  null
  
)

export default component.exports